import { createPublicClient, http, type PublicClient } from 'viem';
import type { ChainId } from '../api/vault-config';
import { getChainFromConfig } from '../utils/chain-utils';

// Cache to store PublicClient instances for different chains
const clients: Map<ChainId, PublicClient> = new Map();

/**
 * Gets or creates a PublicClient instance for the specified blockchain
 * @param chainId - The blockchain ID
 * @returns A PublicClient instance for interacting with the specified chain
 */
const getClient = async (chainId: ChainId): Promise<PublicClient> => {
  if (!chainId) {
    throw new Error('Chain ID is required');
  }

  if (!clients.has(chainId)) {
    const chain = await getChainFromConfig(chainId);
    const client = createPublicClient({
      chain,
      transport: http(chain.rpcUrls.default.http[0]),
    });
    clients.set(chainId, client);
  }

  const client = clients.get(chainId);
  if (!client) {
    throw new Error(`Client not found for chain ID ${chainId}`);
  }
  return client;
};

export { getClient };
